module.exports = __webpack_public_path__ + "static/img/price3.bf41998.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/price/price3.png
// module id = Rm7D
// module chunks = 1